import intl from 'i18n';
import get from 'lodash/get';
import replace from 'lodash/replace';

import messages from './messages';

export const customFormatter = (val, unit, formats) => {
  let formattedVal = val;
  let formattedUnit = unit;

  let oneOrAfter = formattedVal === 1 ? 'one' : 'other';

  if (unit === 'second' && formattedVal < 60) {
    return intl.formatMessage(messages.seconds_ago);
  }

  if (unit === 'week') {
    formattedUnit = 'day';
    oneOrAfter = 'other';
    formattedVal = val * 7;
  }

  const unitMessage = get(formats, [formattedUnit, 'relativeTime', 'past', oneOrAfter]);

  return replace(unitMessage, '{0}', formattedVal);
};
